import React from 'react';

var _path;

var SvgResourcesMajor = function SvgResourcesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.986 10.835-.987-5.926A3.004 3.004 0 0 0 16 2a1 1 0 1 0 0 2c.552 0 1 .449 1 1 0 .055.005.11.014.165L17.82 10H12a1 1 0 0 0-1 1v.19a2.92 2.92 0 0 0-1-.19c-.35 0-.688.076-1 .19V11a1 1 0 0 0-1-1H2.18l.806-4.835A.92.92 0 0 0 3 5c0-.551.449-1 1-1a1 1 0 0 0 0-2 3.004 3.004 0 0 0-2.999 2.909l-.988 5.926A2.29 2.29 0 0 0 0 11v2.5C0 15.981 2.019 18 4.5 18S9 15.981 9 13.5v-.039c.311-.234.714-.461 1-.461.286 0 .689.227 1 .461v.039c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5V11c0-.029-.009-.136-.014-.165zM7 13.5C7 14.879 5.878 16 4.5 16A2.503 2.503 0 0 1 2 13.5V12h5v1.5zm11 0c0 1.379-1.121 2.5-2.5 2.5a2.502 2.502 0 0 1-2.5-2.5V12h5v1.5z"
  })));
};

export { SvgResourcesMajor as S };
